module.exports = __webpack_public_path__ + "static/media/bet-logo-magnum.56132ef3.png";